import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var Checkbox = React.forwardRef(function Checkbox2({ className, indeterminate = false, onCheckedChange, ...props }, forwardedRef) {
  const innerRef = React.useRef(null);
  React.useEffect(() => {
    if (innerRef.current) innerRef.current.indeterminate = indeterminate;
  }, [indeterminate]);
  const setRefs = React.useCallback(
    (node) => {
      innerRef.current = node;
      if (typeof forwardedRef === "function") forwardedRef(node);
      else if (forwardedRef) forwardedRef.current = node;
    },
    [forwardedRef]
  );
  return /* @__PURE__ */ jsx(
    "input",
    {
      ref: setRefs,
      type: "checkbox",
      className: cn(
        "h-4 w-4 shrink-0 cursor-pointer rounded border border-input accent-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      onChange: (e) => onCheckedChange?.(e.target.checked),
      ...props
    }
  );
});

export { Checkbox };
//# sourceMappingURL=chunk-KAFWCBYS.js.map
//# sourceMappingURL=chunk-KAFWCBYS.js.map